/* 🤖 this file was generated by svg-to-ts*/
export const icoLinkedin: {
  name: 'linkedin';
  data: string;
} = {
  name: 'linkedin',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 21H4.8A1.8 1.8 0 013 19.2V4.8A1.8 1.8 0 014.8 3h14.4A1.8 1.8 0 0121 4.8v14.4a1.8 1.8 0 01-1.8 1.8zM8.4 10.2H5.7v8.1h2.7v-8.1zm0-3.15c-.015-.767-.52-1.35-1.342-1.35-.821 0-1.358.583-1.358 1.35 0 .75.52 1.35 1.326 1.35h.016c.837 0 1.358-.6 1.358-1.35zm9.9 6.712c0-2.431-1.31-3.562-3.055-3.562-1.408 0-2.038.767-2.392 1.306v-1.12H10.2c.034.741 0 7.914 0 7.914h2.653v-4.42c0-.24.017-.471.087-.642.193-.47.63-.963 1.361-.963.962 0 1.345.725 1.345 1.79V18.3H18.3l.001-4.539z" fill="#909090"/></svg>`
};
